import { getType } from 'deox';
import { fetchSettings, updateSettings } from 'modules/settings';
import { takeEvery, put, call, select, delay } from 'redux-saga/effects';
import { listBackendSettings } from 'utils/apiWrapper';
import { getUserKey } from 'modules/user';
import { isNil } from 'ramda';
import { BackendSettings } from 'api';
import ErrorLogger from '../../components/ErrorLogger';

export function* fetchSettingsSaga() {
  let userKey: string | undefined | null;

  while (isNil(userKey)) {
    userKey = yield select(getUserKey);

    if (!userKey) {
      yield delay(100);
    }
  }

  try {
    const settings: BackendSettings = yield call(listBackendSettings, userKey);
    yield put(updateSettings({ ...settings, isFetched: true }));
  } catch (error) {
    ErrorLogger.trigger(error);
    yield put(updateSettings({ isFetched: true }));
  }
}

export default function* settingsSaga() {
  yield takeEvery(getType(fetchSettings), fetchSettingsSaga);
}
